import { TOAST_IDS } from '@/config/toast-ids';
import { translateToast } from '@/lib/i18n/toast-translator';
import { showToast } from '@/lib/ui/toast';

function truncateAddress(address: string): string {
  if (address.length <= 12) return address;
  return `${address.slice(0, 4)}...${address.slice(-4)}`;
}

/**
 * Copy a wallet address to the clipboard and show a success toast.
 * Toast message: "Main Wallet address copied: 7of6...HtSU"
 *
 * @param address     Solana public key (base58)
 * @param walletName  Display name of the wallet (e.g. "Main Wallet")
 */
export function copyWalletAddress(address: string, walletName: string): void {
  void navigator.clipboard.writeText(address).then(() => {
    showToast({
      id: TOAST_IDS.WALLET_ADDRESS_COPIED,
      message: translateToast('wallet.addressCopied', {
        walletName,
        address: truncateAddress(address),
      }),
      variant: 'success',
    });
  });
}
